import React from 'react';
import Tooltip from '@zg-rentals/multibrand-ui/lib/Tooltip';
import HelpCircleFill from '@zg-rentals/multibrand-ui/lib/icons/HelpCircleFill';

import './style.scss';

class HelpTooltip extends React.Component<React.PropsWithChildren> {
  render(): React.ReactNode {
    return (
      <Tooltip trigger="click" position="top" type="primary" className="HelpTooltip">
        <Tooltip.Target>
          <HelpCircleFill size="sm" colorType="text-secondary" />
        </Tooltip.Target>
        {this.props.children}
      </Tooltip>
    );
  }
}

export default HelpTooltip;
